import React from "react";
import { Select as MuiSelect, MenuItem } from "@material-ui/core";
import { useField } from "formik";
import { getTip } from "../../helpers/helpers";

export function Select({
  className,
  label,
  options = [],
  multiple,
  tip,
  defaultValue = "",
  ...other
}) {
  return (
    <>
      <label className="d-block mb-0">
        {label && <div className="mb-2">{label}</div>}
        <MuiSelect
          className={`form-control ${className}`}
          defaultValue={defaultValue}
          disableUnderline={true}
          multiple={multiple}
          data-testid="select"
          {...other}
        >
          {options.map(({ value, label }) => (
            <MenuItem key={value} value={value} children={label} />
          ))}
        </MuiSelect>
      </label>
      {tip && <div>{tip}</div>}
    </>
  );
}

export function MappedSelect(props) {
  const [field, meta] = useField(props.name);
  return (
    <div className={`form-group ${props.className}`}>
      <Select {...field} {...props} tip={getTip(meta, props.tip)} />
    </div>
  );
}
